import {Component} from 'react';
import {connect} from "react-redux";
import { getSplitIOTreatments } from '../../modules/splitIO';

// const USER_TRAFFIC_TYPE = "user";
// const ORGANIZATION_TRAFFIC_TYPE = "org";
// const BUSINESS_GROUP_TRAFFIC_TYPE = "business_group";
const ANNONYMOUS_TRAFFIC_TYPE = "annonymous";

class SplitIOTreatment extends Component{
    componentDidMount(){
        const{token, featureName, trafficType, dispatch} = this.props;

        let actualTrafficType = trafficType;
        if (typeof actualTrafficType === "undefined") {
            actualTrafficType = ANNONYMOUS_TRAFFIC_TYPE;
        }

        dispatch(getSplitIOTreatments(featureName, actualTrafficType, token));
    }
    render(){
        const {treatments, featureName, treatmentValue, children} = this.props;
        let treatment = "control";
        if (typeof treatments === 'object' && featureName in treatments) {
            treatment = treatments[featureName];
        }
        
        return(children(treatment, featureName, treatmentValue))
    }
}

const withState = connect(state =>{
    const {treatments} = state.splitIO;
    const { user } = state;
    return{ treatments, token: user?user.token:null }
})

export default withState(SplitIOTreatment);


// WEBPACK FOOTER //
// ./src/components/splitio/splitioTreatment.js